import { AngleDown, ChakraBox, Menu, MenuOption } from '@equip.health/ui';

import ConfirmModal from '~/components/common/ConfirmModal';

interface VoidOrCloseTaskModalProps {
  body: string;
  id: string;
  isDisabled?: boolean;
  isOpen: boolean;
  menuLabel: string;
  onClose: () => void;
  onConfirm: () => void;
  onSelectReason: (value: string) => void;
  reasonOptions: MenuOption[];
  selectedReason: string;
  title: string;
}

const VoidOrCloseTaskModal = ({
  body,
  id,
  isDisabled,
  isOpen,
  menuLabel,
  onClose,
  onConfirm,
  onSelectReason,
  reasonOptions,
  selectedReason,
  title,
}: VoidOrCloseTaskModalProps) => (
  <ConfirmModal
    body={body}
    cancelLabel="Cancel"
    confirmLabel="Confirm"
    confirmVariant="accent.critical"
    id={id}
    isDisabled={isDisabled}
    isOpen={isOpen}
    onClose={onClose}
    onConfirm={onConfirm}
    title={title}
  >
    <ChakraBox margin="8px 0px 8px -5px">
      <Menu
        backgroundColor="neutral.background.secondary"
        border="none"
        borderRadius="20px"
        buttonContent={
          reasonOptions.find(({ value }) => value === selectedReason)?.node
        }
        buttonHeight="50px"
        buttonVariant="ghost"
        color="neutral.secondary"
        enableGrouping
        fontSize="14px"
        fontWeight="normal"
        formMarginBottom="28px"
        height="48px"
        icon={<AngleDown fill="teal" height="15px" width="15px" />}
        id={`${id}_reason`}
        isRequired
        label={menuLabel}
        listMaxHeight="250"
        menuListZIndex={2000}
        menuWidth="100%"
        onSelect={onSelectReason}
        options={reasonOptions}
        overflow="scroll"
        placeholder="Select..."
        textAlign="left"
        wrapMenuListInPortal
      />
    </ChakraBox>
  </ConfirmModal>
);

export default VoidOrCloseTaskModal;
